import FinancialsProvider from './Providers/FinancialsProvider'
import FinancialsAbilityProvider from './Providers/FinancialsAbilityProvider'
import FinancialsActionReasonPopupProvider from './Providers/FinancialsActionReasonPopupProvider'
import FinancialsRebatesProvider from './Providers/FinancialsRebatesProvider'
import FinancialsCognusARProvider from './Providers/FinancialsCognusARProvider'
import FinancialsAdminProvider from './Providers/FinancialsAdminProvider'
import { FinancialsRouter } from './Router/Router'
import { FinancialsContainer } from './Container/Container'
import FinancialsPopupProvider from './Providers/FinancialsPopupProvider'

export const Financials = () => (
  <FinancialsAbilityProvider>
    <FinancialsPopupProvider>
      <FinancialsProvider>
        <FinancialsRebatesProvider>
          <FinancialsCognusARProvider>
            <FinancialsAdminProvider>
              <FinancialsActionReasonPopupProvider>
                <FinancialsContainer>
                  <FinancialsRouter />
                </FinancialsContainer>
              </FinancialsActionReasonPopupProvider>
            </FinancialsAdminProvider>
          </FinancialsCognusARProvider>
        </FinancialsRebatesProvider>
      </FinancialsProvider>
    </FinancialsPopupProvider>
  </FinancialsAbilityProvider>
)
